import React from "react";

/**
 * Icon-only edit/view-only indicator, shared by all sport scoreboards.
 * Accessible name is provided via aria-label/title (no visible text label).
 */
const PermissionBadge = ({ isReadOnlyMode }) => (
  <div className="permission-indicator" title={isReadOnlyMode ? "View only" : "Can edit score"}>
    {isReadOnlyMode ? (
      <span className="view-only-badge" role="img" aria-label="View only">👁️</span>
    ) : (
      <span className="edit-access-badge" role="img" aria-label="Can edit score">✏️</span>
    )}
  </div>
);

export default PermissionBadge;
